module.exports = __webpack_public_path__ + "img/Poster_605CommonSpace.6e64c68d.png";